// Pure floor-plan geometry helpers extracted from AdvancedTablesPage.
//
// Everything here is self-contained: plain data in, plain data out, no closures
// over React state/hooks and no Konva node refs. Kept separate so the canvas
// page can focus on stateful drag/pan/zoom wiring while these deterministic
// bits stay unit-testable in isolation.

export const MIN_SCALE = 0.3;
export const MAX_SCALE = 3;
export const clampScale = (s: number) => Math.max(MIN_SCALE, Math.min(MAX_SCALE, s));

// Tables snap to a grid as you drag them - keeps the plan tidy and lets a row
// of identical tables actually line up. The grid is in layout coords, so it
// behaves the same regardless of zoom level.
export const SNAP = 16;
export const snap = (v: number) => Math.round(v / SNAP) * SNAP;
